const data = {
  filter: {
    title: "filter",
    pageName: "filter",
    genre: "filter",
    ignoreSaveFilter: true,
    hideFilter: true,
    filters: [
    ],
  },
  header: {
    title: "Change Password\n",
  },
  component: {
    type: "custom",
  },
};

export default data;
